<template>
  <div :class="{'vueEditor': true, 'ktext': true, 'vueEditorSimple': simple}">
    <quill-editor v-model="privateContent"
                  :options="editorOption"
                  @change="$emit('change', $event)"
                  @blur="$emit('blur', $event)"
                  @focus="$emit('focus', $event)"
                  @ready="$emit('ready', $event)"></quill-editor>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
const Link = Quill.import('formats/link')
Link.sanitize = (url) => url

Quill.register('modules/ImageExtend', ImageExtend)

let toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
  ['blockquote', 'code-block', 'formula'], // 引用  代码块
  // [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ script: 'sub' }, { script: 'super' }], // 上标/下标
  // [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  // [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除文本格式
  ['link', 'image', 'video'], // 链接、图片、视频
  ['sourceEditor'], // 源码编辑
]
let toolbarSimpleOptions = [['image']]
let headers = uploadHeaders()
export default {
  name: 'editor',
  components: {
    quillEditor,
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    simple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    content(val) {
      this.privateContent = val
    },
  },
  data: function () {
    return {
      privateContent: this.content,
      editorOption: {
        placeholder: this.placeholder,
        modules: {
          // toolbar: toolbarSimpleOptions,
          toolbar: {
            container: this.simple ? toolbarSimpleOptions : toolbarOptions,
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              },
              shadeBox: null,
              // 添加工具方法
              sourceEditor: function () {
                const container = this.container
                const firstChild = container.nextElementSibling.firstChild
                // 在第一次点击源码编辑的时候，会在整个工具条上加一个div，层级比工具条高，再次点击工具条任意位置，就会退出源码编辑。可以在下面cssText里面加个背景颜色看看效果。
                if (!this.shadeBox) {
                  let shadeBox = (this.shadeBox = document.createElement('div'))
                  shadeBox.style.cssText =
                    'position:absolute; top:0; left:0; width:100%; height:100%; cursor:pointer'
                  container.style.position = 'relative'
                  container.appendChild(shadeBox)
                  firstChild.innerText = firstChild.innerHTML
                  shadeBox.addEventListener(
                    'click',
                    function () {
                      this.style.display = 'none'
                      firstChild.innerHTML = firstChild.innerText.trim()
                    },
                    false
                  )
                } else {
                  this.shadeBox.style.display = 'block'
                  firstChild.innerText = firstChild.innerHTML
                }
              },
            },
          },
          ImageExtend: {
            loading: true,
            name: 'img',
            action: imgUploadUrl(),
            headers: (xhr) => {
              xhr.setRequestHeader('Authorization', headers['Authorization'])
            },
            response: (res) => {
              if (res.code === 0 && res.data) {
                return res.data.url
              } else {
                this.$message.error('富文本编辑器图片上传异常')
              }
            },
          },
        },
      },
    }
  },
  mounted() {
    this.initButton()
  },
  methods: {
    // 在使用的页面中初始化按钮样式
    initButton: function () {
      // 样式随便改
      const sourceEditorButtons = [
        ...document.querySelectorAll('.ql-sourceEditor'),
      ]
      sourceEditorButtons.forEach((item) => {
        item.style.cssText = 'font-size:18px'
        // 加了elementui的icon
        item.classList.add('el-icon-edit-outline')
        // 鼠标放上去显示的提示文字
        item.title = '源码编辑'
      })
    },
  },
}
</script>

<style scoped lang="less">
.vueEditor {
  /deep/ .ql-toolbar {
    background: #f9f9f9;
  }
  /deep/ .ql-container {
    min-height: 300px;
    max-height: 700px;
    background: #fff;
    overflow: auto;
  }
}
.vueEditorSimple {
  /deep/ .quill-editor {
    display: flex;
  }
  /deep/ .ql-toolbar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #f9f9f9;
    padding: 0;

    .ql-formats {
      margin-right: 0;
    }
  }
  /deep/ .ql-container {
    flex: 1;
    min-height: 40px !important;
    max-height: 500px;
    background: #fff;
    border-top: 1px solid #ccc !important;
    border-left: 0;
    overflow: auto;
  }
}
</style>
